__turbopack_context__.v({
  "filter-stack": "filter-content-module-scss-module__tfU8Aq__filter-stack",
  "filter-stack__item": "filter-content-module-scss-module__tfU8Aq__filter-stack__item",
  "switch-filter": "filter-content-module-scss-module__tfU8Aq__switch-filter",
});
